import React from 'react';
import { Box, Text, Stack } from '@chakra-ui/react';

export interface SubscriptionBoxProps {
    name: string;
    text: string;
    limitText?: string;
    previousPrice?: string;
    currentPrice?: string;
    textBelowPrice?: string;
}

const SubscriptionBox: React.FC<SubscriptionBoxProps> = ({
    name,
    text,
    limitText,
    previousPrice,
    currentPrice,
    textBelowPrice,
}) => {
    return (
        <Box
            bg="#eee"
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            position="relative"
            padding="0.9375rem"
            height={'100%'}
        >
            <Stack spacing="0.625rem">
                <Text fontSize="1rem" color="#171717">
                    Abonament
                </Text>
                <Text fontWeight="bold" fontSize="1.55rem" color="#1AAC7A">
                    {name}
                </Text>
                <Text
                    fontSize="0.8125rem"
                    fontStyle="normal"
                    color="#171717"
                    minH={{
                        base: 'auto',
                        md: '20',
                    }}
                >
                    {text}
                </Text>
                {limitText && (
                    <Text
                        fontWeight="700"
                        fontSize={'sm'}
                        fontStyle="normal"
                        minH={{
                            base: '10',
                            md: '20',
                        }}
                        lineHeight={'1.25rem'}
                    >
                        {limitText}
                    </Text>
                )}
                {previousPrice && (
                    <Box>
                        <Text
                            fontSize=".75rem"
                            fontWeight="400"
                            color="#171717"
                            textDecoration="line-through"
                            lineHeight={'1rem'}
                            transform={'translateY(-1rem)'}
                            height={0}
                        >
                            {previousPrice}
                        </Text>
                        {currentPrice && (
                            <Text
                                fontSize="1.55rem"
                                fontWeight="600"
                                color="#DD1C4A"
                                lineHeight="1.8125rem"
                            >
                                {currentPrice}
                            </Text>
                        )}
                        {textBelowPrice && (
                            <Text
                                fontSize=".75rem"
                                lineHeight={'1.25rem'}
                                fontWeight="400"
                                color="#171717"
                                mt={1}
                            >
                                {textBelowPrice}
                            </Text>
                        )}
                    </Box>
                )}
                {!previousPrice && (
                    <>
                        {currentPrice && (
                            <Text
                                fontSize="1.55rem"
                                fontWeight="600"
                                color="#171717"
                                lineHeight={'1.8125rem'}
                            >
                                {currentPrice}
                            </Text>
                        )}
                        {textBelowPrice && (
                            <Text
                                fontSize=".75rem"
                                lineHeight={'1.25rem'}
                                fontWeight="400"
                                color="#171717"
                            >
                                {textBelowPrice}
                            </Text>
                        )}
                    </>
                )}
            </Stack>
        </Box>
    );
};

export default SubscriptionBox;
